import { lazy } from 'react';

export const Inventory = lazy(() => import('./Inventory.component'));
